// extracted by mini-css-extract-plugin
export default {"inOfficeButton":"InOfficeButton_inOfficeButton__l-Ak4","buttonText":"InOfficeButton_buttonText__5XLFK"};